<template>
  <div
      :class="[
        'w-100 vform-text-display position-relative', 
      config.emphasized ? 'vform-emphasized font-weight-bold' : '', 
      config.backgroundColor ? 'with-bg' : 'without-bg',
      templateMode ? 'template-mode' : '',
      config.textAlignment ? 'text-align-' + config.textAlignment : '',
      config.textSize ? 'text-size-' + config.textSize : 'text-size-medium',
      config.noMarginBottom ? 'no-margin-bottom' : '',
      config.isInline && isTopBottomBar ? 'inline-element no-margin-bottom' : '',
      ]"
      :style="{
            backgroundColor: config.backgroundColor ? config.backgroundColor : '',
            color: !config.emphasized && config.fontColor ? config.fontColor : '',
          }">
    <slot name="dropzone"></slot>
    <!--todo: check if preview is really necessary anymore...-->
    <preview
        v-if="getImage(config, lang)"
        :asset-id="getImage(config, lang)"
        :may-load-now="isActive"
        :preview-id="getImage(config, lang)"
        :removable="false"
        class="mini mr-2 float-left"
        source="asset"
    />
    <editor-overlay
        v-if="editable"
        :active="editorSelected"
        :has-template="!!config.templateId"
        @editProperty="editProperty"
        @editTemplate="editTemplate"
        @removeBlock="$emit('removeBlock')"
    />
    <div
        :id="uniqueId"
        :class="[
          config.backgroundColor ? 'with-bg' : 'without-bg',
          templateMode ? 'template-mode' : '',
        ]"
        contenteditable="false"
        @input="onInput"
        v-html="safeHtml"
        @click.stop="doNothing"></div>
  </div>
</template>

<script>
import ElementMixin from "@/components/vForm/mixins/ElementMixin.js.vue";
import Preview from "@/components/vForm/viewer/Preview";
import EditorOverlay from "./EditorOverlay";
import {sanitizeHtmlString} from "./textUtils";
export default {
  name: "Text",
  components: {
    Preview,
    EditorOverlay
  },
  mixins: [ElementMixin],
  props: {
    templateMode: {type: Boolean, default: () => {return false}, required: false},
  },
  computed: {
    safeHtml() {
      let html = this.getLabel(this.config, this.$store.getters.getSelectedFormLanguage);
      if (!html) return this.placeholders.LONG;
      html = this.normalizeHTML(html);
      return sanitizeHtmlString(html);
    },
  },
  watch: {
    config: {
      deep: true,
      handler() {
        // re-render on config change
        this.forceReRenderKey++;
      }
    }
  },
  beforeMount() {
    this.setUniqueId();
  },
  mounted() {
    this.increaseCounter();
    this.addListener(document, "click", this.documentClick, 'textdisplay');
  },
  methods: {
    normalizeHTML(html) {
      if(html.includes("&lt;") || html.includes("&gt;")) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      }
      return html;
    },
    documentClick() {
      this.leaveEditing(this.uniqueId);
    },
    setEditing() {
      if (this.editable) {
        this.editing = true;
        this.setCursor(this.uniqueId);
      }
    },
    onInput(e) {
      this.setLabel(this.config, this.$store.getters.getSelectedFormLanguage, e.target.innerText);
    },
    validate() {
      return true;
    },
    checkRequired() {
      return true;
    },
    getData() {
      return {data: this.getLabel(this.config, this.$store.getters.getSelectedFormLanguage), type: 'text'};
    }
  }
}
</script>

<div lang="scss">
.vform-text-display {
  &.no-margin-bottom {
    margin-bottom: 0 !important;
  }
  ul, ol {
    padding-left: 40px;
  }
}
[dir="rtl"] .vform-text-display {
  ul, ol {
    padding-left: 0;
    padding-right: 40px;
  }
}
</div>

<style lang="scss" scoped>
// inner div
.with-bg {
  padding: 5px 6px;
}

// outer div
.vform-text-display {
  white-space: pre-wrap;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
  margin-bottom: 0.6em;
  &.with-bg {
    width: calc(100% + 20px) !important;
  }

  &.inline-element {
    align-content: center;

    // with background: full height, centered, padded — but must stay auto-width to remain inline
    &.with-bg {
      width: auto !important;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1em;
    }
    // without background: no extra styles
  }
  &.template-mode {
    width: 100% !important;
  }
}
.text-size-small {
  font-size: 0.8em;
}
.text-size-large {
  font-size: 1.3em;
}
.text-align-center {
  text-align: center;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left;
}
.text-align-justify {
  text-align: justify;
}
</style>
